
export const JOINAPP_EXPREALTY = 'https://joinapp.exprealty.com/';
export const JOIN_EXPREALTY_US_CONTACT = 'https://join.exprealty.com/contact/';
export const JOIN_EXPREALTY_CA_CONTACT = 'https://join.exprealty.com/contact-ca/';